import { User } from '@intelligent-play-v2/domain';

const VIVACITY_EMAIL_DOMAIN = '@vivacitylabs.com';

/**
 * Whether a user is a Vivacity employee, by email domain.
 *
 * Gates internal-only tooling that a customer admin has no business seeing — sensor
 * calibration, for one. A UI-visibility check, not a security boundary: the endpoints
 * behind it are guarded on the server.
 */
export const isVivacityUser = (user: User | null): boolean =>
  user?.email?.trim().toLowerCase().endsWith(VIVACITY_EMAIL_DOMAIN) ?? false;
